import ImgComparer from './img-comparer.element.js';

export default ImgComparer;

ImgComparer.define('wje-img-comparer', ImgComparer);
